import { render, staticRenderFns } from "./decoration-policy-detail-info.vue?vue&type=template&id=24d1daf4&scoped=true&"
import script from "./decoration-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./decoration-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./decoration-policy-detail-info.vue?vue&type=style&index=0&id=24d1daf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1daf4",
  null
  
)

export default component.exports